@let etape = etapeSelectionnee();
<div class="gap-lg grid">
  <p class="pt-lg text-content-secondary">
    Vous pouvez retirer des aptitudes, ainsi que des interrelations et des productions. Les aptitudes visibles ici sont
    celles qui ont été ajoutées à l’étape. Une aptitude minimum.
  </p>
  @if (peutModifier()) {
    <div class="p-xxs" hlmField>
      <label [for]="'autocomplete-aptitude'" hlmFieldLabel>Aptitude</label>
      <hlm-autocomplete
        [(ngModel)]="nouvelleAptitude"
        [id]="'autocomplete-aptitude'"
        [filteredOptions]="aptitudesFiltrees()"
        (searchChange)="filterAptitudes($event)"
        placeholder="Rechercher une aptitude de l'étape"
        autocompleteSearchClass="border-stroke-neutral-medium"
      />
    </div>
  }
  @if (etape) {
    @for (control of objectifs.controls; track $index; let idx = $index) {
      <app-module-objectif-group
        [index]="idx"
        [form]="control"
        [etape]="etape"
        (supprimerAptitude)="supprimerAptitude(idx)"
      />
    }
  }
</div>
